<template>
  <div v-if="tampil" class="langganan-banner" :class="{ genting: l.sisa_hari <= 3, tenggang }" :role="tenggang ? 'alert' : 'status'">
    <i class="fa-solid ikon" :class="tenggang ? 'fa-triangle-exclamation' : 'fa-calendar-day'" aria-hidden="true"></i>
    <p v-if="tenggang" class="isi">
      <strong>Masa langganan telah berakhir.</strong> {{ kalimatTenggang }}
    </p>
    <p v-else class="isi">
      <strong>Masa langganan {{ sisa }}</strong>, {{ tanggal }}.
      <template v-if="besokTerkunci">Mulai besok aplikasi terkunci sampai perpanjangan dibayar.</template>
      <template v-else>Bayar perpanjangan sebelum tanggalnya supaya aplikasi tidak terkunci.</template>
    </p>
    <a href="" class="aksi" @click.prevent="panduan">Cara perpanjang</a>
    <!-- Masa tenggang: tidak bisa disembunyikan, aplikasi akan terkunci. -->
    <button v-if="!tenggang" type="button" class="tutup" title="Sembunyikan sampai besok" aria-label="Sembunyikan sampai besok" @click="tutup">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { useAppStore } from "@/stores/app-store";
import {
  BATAS_PERINGATAN_HARI,
  kalimatSisa,
  kalimatTenggang,
  besokTerkunci,
  tanggalPanjang,
  bukaPanduanLangganan,
} from "@/helper/langganan";

const KUNCI = "langganan-banner-ditutup";

function hariIni() {
  return DateTime.now().setZone("Asia/Makassar").toISODate();
}

export default {
  name: "LanggananBanner",
  data() {
    let ditutup = null;
    try {
      ditutup = localStorage.getItem(KUNCI);
    } catch (e) {
      ditutup = null;
    }
    return { ditutup };
  },
  computed: {
    l() {
      return useAppStore().langganan;
    },
    tenggang() {
      return !!this.l?.masa_tenggang && !this.l.habis;
    },
    tampil() {
      const l = this.l;
      if (!l || l.habis) return false;
      if (this.tenggang) return true;
      return l.sisa_hari <= BATAS_PERINGATAN_HARI && this.ditutup !== hariIni();
    },
    kalimatTenggang() {
      return kalimatTenggang(this.l);
    },
    besokTerkunci() {
      return besokTerkunci(this.l);
    },
    sisa() {
      return kalimatSisa(this.l.sisa_hari);
    },
    tanggal() {
      return tanggalPanjang(this.l.berakhir);
    },
  },
  methods: {
    panduan() {
      bukaPanduanLangganan(this.$router);
    },
    // Disembunyikan sampai besok, bukan selamanya: besok angkanya berubah dan perlu dilihat lagi.
    tutup() {
      this.ditutup = hariIni();
      try {
        localStorage.setItem(KUNCI, this.ditutup);
      } catch (e) {
        /* penyimpanan diblokir: cukup tersembunyi di sesi ini */
      }
    },
  },
};
</script>

<style scoped>
.langganan-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 16px 0;
  padding: 10px 8px 10px 16px;
  border-radius: 10px;
  background: var(--warn-bg);
  color: var(--warn-ink);
  border: 1px solid var(--warn-line);
  line-height: 1.45;
}
.langganan-banner.genting {
  background: var(--brand-sun);
  color: var(--brand-sun-ink);
  border-color: transparent;
}
.langganan-banner.tenggang {
  background: var(--danger-bg);
  color: var(--danger-ink);
  border-color: transparent;
  padding-right: 16px;
}
.ikon {
  font-size: 16px;
  flex: none;
}
.isi {
  margin: 0;
  flex: 1;
}
.aksi {
  color: inherit;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: underline;
}
.tutup {
  flex: none;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  transition: background-color 140ms ease, transform 140ms var(--ease-out);
}
.tutup:active {
  transform: scale(0.94);
}
@media (hover: hover) and (pointer: fine) {
  .tutup:hover {
    background: color-mix(in srgb, currentColor 12%, transparent);
  }
}
@media (max-width: 720px) {
  .langganan-banner {
    flex-wrap: wrap;
    margin: 8px 8px 0;
  }
  .ikon {
    display: none;
  }
  .isi {
    flex-basis: calc(100% - 44px);
  }
}
</style>
